import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) { toast.error("Use at least 8 characters"); return; }
    if (pwd !== confirm) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: pwd });
      toast.success("Password updated");
      setCurrent(""); setPwd(""); setConfirm("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to change password");
    } finally { setBusy(false); }
  };

  return (
    <div className="p-6 md:p-10 max-w-xl mx-auto" data-testid="change-password-page">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest font-mono-plex text-slate-500">Account</div>
        <h1 className="font-heading text-4xl md:text-5xl font-black">Change password</h1>
        <p className="text-slate-500 mt-1 text-sm">Use at least 8 characters. Mix letters and numbers for extra safety.</p>
      </div>
      <Card className="p-6 border-slate-200 shadow-none">
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Current password</Label>
            <Input type="password" data-testid="cp-current" required value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1.5" />
          </div>
          <div>
            <Label>New password</Label>
            <Input type="password" data-testid="cp-new" required value={pwd} onChange={(e) => setPwd(e.target.value)} className="mt-1.5" />
          </div>
          <div>
            <Label>Confirm new password</Label>
            <Input type="password" data-testid="cp-confirm" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" />
          </div>
          <Button type="submit" disabled={busy} data-testid="cp-submit" className="bg-slate-900 hover:bg-slate-800">
            {busy ? "Updating…" : "Update password"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
